module.exports = __webpack_public_path__ + "img/icon-type-5.9542ad1c.png";